<div class="custom-modal-container ">
  <div class="custom-modal-container-content primary pdf-download-dialog">
    <div (click)="onClose()" class="close-button">
      <svg class="icon-svg">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#dialog-cross"></use>
      </svg>
    </div>
    <!--<i class="modal-icon" *ngIf="context && context.svg">
            <svg class="icon-svg">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" [attr.xlink:href]="context.svg.xlinkHref"></use>
            </svg>
        </i>-->
    <div class="content-container">
      <h2 class="modal-title" *ngIf="context && context.title">{{ context.title | translate }}</h2>
      <p class="modal-paragraph" *ngIf="context && context.description">{{ context.description | translate }}</p>
      <ul class="modal-list">
        <li *ngFor="let document of context.model.documents">
          <div class=" pdf-download-file-name">{{ document.name }}</div>
          <a class="empty-primary-button" (click)="download(document)">{{ 'Download' | translate }}</a>
        </li>
      </ul>
      <div class="button-container">
        <a class="primary-button" (click)="download(null)">{{ 'Download all as zip' | translate }}</a>
      </div>
      <!--<div class="button-container">
                <div *ngIf="context && context.buttons">
                    <a class="primary-button" *ngFor="let button of context.buttons" (click)="onClick(button.callback)">{{button.text | translate}}</a>
                </div>
            </div>-->
      <!--<a href="{{context.link.url}}" *ngIf="context.link" target="_blank">{{context.link.text | translate}}</a>-->
    </div>
  </div>
</div>
